import { render, staticRenderFns } from "./RadioButton.vue?vue&type=template&id=53aee1d7&"
import script from "./RadioButton.vue?vue&type=script&lang=js&"
export * from "./RadioButton.vue?vue&type=script&lang=js&"
import style0 from "./RadioButton.vue?vue&type=style&index=0&id=53aee1d7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports